import { Component, Input, OnInit, Output, EventEmitter, ViewChild, SimpleChanges, Inject, Injector, AfterViewInit } from '@angular/core';
import { APLCategory } from '../services/apl-category.model';
import { BaseComponent } from 'src/app/common/base/base.component';
import { Subscription, Observable } from 'rxjs';
import { APLGroup } from '../services/apl-group.model';
import { AplCategoryV2CategoriesComponent } from '../apl-category-v2/apl-category-v2-categories/apl-category-v2-categories.component';
import { APLGroupRefresh } from '../store/apl-group/apl-group.action';
import { PrivilegeEnum } from 'src/app/common/enumerations/privilege-enum';
import { APLCategoryPopupComponent, APLCategoryPopupParameters } from '../apl-category-v2/dialogs/apl-category-popup/apl-category-popup.component';
import { APLContainer } from '../services/apl-container.model';
import { APLCategoryRefresh } from '../store/apl-category/apl-category.action';
import { CatalogService } from '../../catalogs/catalog-service';
import { PendingCatalogType } from 'src/app/services/pending-approvals/pending-approval';
import { PendingApprovalsRefresh } from '../../pending-approvals-v2/store/pending-approvals/pending-approvals.action';

@Component({
  selector: 'app-apl-container',
  templateUrl: './apl-container.component.html',
  styleUrls: ['./apl-container.component.scss']
})
export class APLContainerComponent extends BaseComponent implements OnInit, AfterViewInit {
  @Input() enableMove = false;
  @Input() filter: string = '';

  loading!: boolean;

  aplCategorySubscription!: Subscription;
  aplCategory$!: Observable<APLCategory[]>;
  aplCategories!: APLCategory[];
  aplCategoriesFiltered!: APLCategory[];
  aplCategoriesPending!: APLCategory[];
  nonPendingCategories!: APLCategory[];

  aplCategoryApproval = false;
  aplCategoryEdit = false;
  aplCategoryDelete = false;

  aplGroups!: APLGroup[];
  aplGroups$!: Observable<APLGroup[]>;
  aplGroupsSubscription!: Subscription;

  aplContainersFiltered: APLContainer[] = [];
  aplContainer!: APLContainer;
  openContainerIDs: number[] = [];

  loadingMessage!: string;

  labelTitle!: string;
  labelCategories!: string;
  labelFilter!: string;

  createCategoryPrivilege!: boolean;
  requestUserPrivilege!: boolean;

  constructor(
    protected override injector: Injector,
    private catalogService: CatalogService
  ) {
    super(injector);
  }

  ngAfterViewInit(): void {

  }

  ngOnInit(): void {
    // this.store.dispatch(new APLGroupRefresh());
    // this.store.dispatch(new APLCategoryRefresh());
    this.loadGroups();
    this.getPrivilege();
    this.setLabels();
    this.setPermissions();
  }

  applyFilter(filter: string) {
    filter = filter?.trim().toLowerCase();
    this.filter = filter;

    this.aplContainersFiltered.forEach(container => {
      container.hasMatch = false; // Reset match flag
      container.aplCategories.forEach(category => {
        category.hasMatch = false;
        category.aplGroups?.forEach(group => {
          group.hasMatch = false;
        });
      });
    });

    if (!filter || filter.length < 3) {
      this.aplContainersFiltered.forEach(container => {
        container.open = false;
        container.aplCategories.forEach(category => category.open = false);
      });
      return;
    }

    this.aplContainersFiltered.forEach(container => {
      let containerHasMatch = false;

      container.aplCategories.forEach(category => {
        let categoryHasMatch = false;

        category.aplGroups?.forEach(group => {
          let groupHasMatch = false;

          group.aplGroupRoles?.forEach(groupRole => {
            const matchingUserRoles = groupRole.role?.userRole?.filter(userRole =>
              userRole.user?.name?.toLowerCase().includes(filter) ||
              userRole.user?.initials?.toLowerCase().includes(filter)
            );

            if (matchingUserRoles?.length) groupHasMatch = true;
          });

          if (
            group.aplGroupRoles?.some(gr =>
              gr.role?.name?.toLowerCase().includes(filter) ||
              gr.role?.information?.toLowerCase().includes(filter)
            ) ||
            group.name?.toLowerCase().includes(filter) ||
            group.description?.toLowerCase().includes(filter) ||
            group.aplGroupManagers?.some(gm =>
              gm.user?.name?.toLowerCase().includes(filter) ||
              gm.user?.initials?.toLowerCase().includes(filter)
            ) ||
            group.aplProcedureTrainingCoordinators?.some(c =>
              c.user?.name?.toLowerCase().includes(filter) ||
              c.user?.initials?.toLowerCase().includes(filter)
            )
          ) {
            groupHasMatch = true;
          }

          group.hasMatch = groupHasMatch;
          group.open = groupHasMatch;
          if (groupHasMatch) categoryHasMatch = true;
        });

        if (
          category.aplGroups?.some(g => g.name?.toLowerCase().includes(filter)) ||
          category.name?.toLowerCase().includes(filter) ||
          category.code?.toLowerCase().includes(filter) ||
          category.aplCategoryManagers?.some(cm =>
            cm.user?.name?.toLowerCase().includes(filter) ||
            cm.user?.initials?.toLowerCase().includes(filter)
          )
        ) {
          categoryHasMatch = true;
        }

        category.open = categoryHasMatch;
        category.hasMatch = categoryHasMatch;
        if (categoryHasMatch) containerHasMatch = true;
      });

      container.open = containerHasMatch;
      container.hasMatch = containerHasMatch;
    });

  }



  loadCategories() {
    this.aplCategory$ = this.store.select(state => state.APLCategory.APLCategories);
    this.aplCategorySubscription = this.aplCategory$.subscribe((data: APLCategory[]) => {
      if (data?.length) {
        this.aplCategories = data;
        this.nonPendingCategories = data;
        // Include all pending categories here and filter on category-v2-categories
        this.aplCategories = this.aplCategories.filter(c => !this.aplCategoriesPending.map(p => p.aplCategoryMasterID).includes(c.aplCategoryMasterID));
        this.aplCategories = this.aplCategories.concat(this.aplCategoriesPending);

        this.aplCategories.map(x => {
          x.aplGroups = this.aplGroups?.filter(g => g.aplGroupMaster?.aplCategoryMasterID === x?.aplCategoryMasterID);
          const p = this.aplCategoriesPending?.find(y => y.previousVersionID == x.id);
          if (p) {
            x.newVersion = p;
            x.status = p.status;
          }
        });
        this.aplCategories = this.aplCategories?.sort((a, b) => a.aplCategoryMaster.order - b.aplCategoryMaster.order);
        this.aplCategoriesFiltered = this.utils.cloneDeep(this.aplCategories);
        this.initializeContainers();
      }
    });
  }

  loadGroups() {
    this.loading = true;
    this.aplGroups$ = this.store.select(state => state.APLGroup.all);
    this.aplGroupsSubscription = this.aplGroups$.subscribe(data => {
      if (data?.length) {
        this.aplGroups = data;
        this.aplGroups.map(group => group.aplGroupRoles?.map(groupRole => {
          groupRole.role?.userRole?.sort((a, b) => this.utils.sort(a.order, b.order));
        }));
        this.loadCategoriesPending();
      }
    });
  }

  loadCategoriesPending() {
    this.aplCategory$ = this.store.select(state => state.APLCategory.APLCategoriesWithPending);
    this.aplCategorySubscription = this.aplCategory$.subscribe((data: APLCategory[]) => {
      this.aplCategoriesPending = data.filter(x => x.status < 0);
      this.loadCategories();
    });
  }

  private initializeContainers(): void {
    if (this.aplCategories) {
      // setTimeout(() => {
      //   this.initializeContainers();
      // }, 500);
      // } else {
      // Store all currently open container IDs
      if (this.aplContainersFiltered.length) {
        const openIDs = this.aplContainersFiltered.filter(c => c.open).map(c => c.id);
        this.openContainerIDs.concat(openIDs);
      }

      this.aplContainersFiltered = [];

      const containers: APLContainer[] = [
        { id: 1, name: '1. Operations', type: 1, aplCategories: [] },
        { id: 2, name: '2. Electrical', type: 2, aplCategories: [] },
        { id: 3, name: '3. Mechanical', type: 3, aplCategories: [] },
        { id: 4, name: '4. Safety', type: 4, aplCategories: [] }
      ];

      // Assign categories to containers based on category.type
      for (const category of this.aplCategoriesFiltered) {
        const container = containers.find(c => c.type === category.type);
        if (container) {
          container.aplCategories.push(category);
        }
      }

      // Restore open states
      for (const container of containers) {
        container.open = this.openContainerIDs.includes(container.id);
      }

      this.aplContainersFiltered = containers;
      this.loading = false;

      this.checkPendingApprovals();

    }
  }


  openLink(url: string) {
    window.open(url, '_blank');
  }

  setLabels() {
    this.labelTitle = this.getMessage('APL_Category_AuthorizedPersonsAndTechnicalExperts')?.description;
    this.labelFilter = this.getMessage('APL_Category_Filter')?.description;
    this.labelCategories = this.getMessage('APL_CategorySidePanel_Categories')?.description;
    if (!this.labelTitle) {
      setTimeout(() => {
        this.setLabels();
      }, 500);
    }
  }

  getPrivilege() {
    if (!this.aplCategories) {
      setTimeout(() => {
        this.getPrivilege();
      }, 500);
    }
    else {
      const isCategoryManager = this.aplCategories.some(c => c.aplCategoryManagers?.some(m => m.userID == this.currentUser?.id));
      const isGroupManager = this.aplGroups?.some(g => g.aplGroupManagers?.some(m => m.userID == this.currentUser?.id));
      this.requestUserPrivilege = isCategoryManager || isGroupManager || this.hasPrivilege(PrivilegeEnum.APLCategoryEdit) || this.hasPrivilege(PrivilegeEnum.APLGroupEdit);
    }
  }

  setPermissions() {
    this.aplCategoryApproval = this.hasPrivilege(PrivilegeEnum.APLCategoryApproval);
    this.aplCategoryEdit = this.hasPrivilege(PrivilegeEnum.APLCategoryEdit);
    this.aplCategoryDelete = this.hasPrivilege(PrivilegeEnum.APLCategoryDelete);
    this.createCategoryPrivilege = this.hasPrivilege(PrivilegeEnum.APLCategoryCreate);
  }

  addCategory(containerID: number) {
    const aplCategory = new APLCategory;
    aplCategory.type = containerID;

    const aplContainer = this.aplContainersFiltered.find(c => c.id === containerID);
    if (!aplContainer) {
      console.warn(`Container with ID ${containerID} not found.`);
      return;
    }

    this.dialog.open(APLCategoryPopupComponent, {
      height: 'auto',
      width: '50vw',
      data: {
        aplCategory,
        aplContainer,
        aplContainers: this.aplContainersFiltered
      } as APLCategoryPopupParameters,
    }).afterClosed().subscribe(data => {
      this.onCategoriesChanged(aplContainer);
    });
  }

  onCategoriesChanged(aplContainer: APLContainer) {
    // this.openContainerIDs = aplContainers.filter(a=>a.open == true).map(x => x.id);
    this.openContainerIDs = [aplContainer.id]
    this.store.dispatch(new APLGroupRefresh());
    this.store.dispatch(new APLCategoryRefresh());
    this.loadGroups();
    this.store.dispatch(new PendingApprovalsRefresh());
    // this.initializeContainers();
  }

  checkPendingApprovals() {
    // setTimeout(() => {
    if (this.catalogService.pendingCatalog?.approvalType == PendingCatalogType.APLGroups) {
      const aplGgroup = this.aplGroups.find(ag => ag.id == this.catalogService.pendingCatalog?.pendingID);
      this.applyFilter(aplGgroup!.name ?? '');
      this.catalogService.pendingCatalog = undefined;
    }
    // }, 500);
  }

}
